<template>
  <v-container>
    <v-row justify="space-around" align="center" class="custom-height">
      <v-col cols="12" class="text-center">
        <h1>Upload Your Invoice File</h1>
      </v-col>
    </v-row>
    <v-row justify="center" class="upload-view">
      <v-col cols="12" md="4" class="text-center">
        <v-btn text
        @click="$refs.invoice.click()" color="warning" block>
        <div v-if="file===''">Select Your Invoice file</div>
        <div v-else>{{this.file.name}}</div>
      </v-btn>
      <input v-show="false" ref="invoice" type="file" @change="handleFileUpload">
    </v-col>
      </v-row>
    <v-row justify="center" class="upload-view">
    <v-col cols="12" md="4" class="text-center">
      <v-btn text block color="blue darken-1"
      @click="submitFile()">
      <v-icon class="mr-2">cloud_upload</v-icon>
      UPLOAD
    </v-btn>
  </v-col>
</v-row>
</v-container>

</template>


<script >
import axios from "axios";

export default {
  name: "InvoiceUploadHeader",

  data() {
    return {
      file: '',
    }
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.invoice.files[0];
      this.$store.commit('displaySnackbar', 'File Loaded');
    },

    submitFile() {
      let fileFormData = new FormData();

      if(this.file !== '') {
        fileFormData.set('client', this.$store.getters['auth/user_id']);
        fileFormData.append('invoiceFile', this.file);

        axios({
          method: 'post',
          url: process.env.API_URL + '/invoices/upload',
          data: fileFormData,
          config: {
            headers: {
              'Content-Type':
                'multipart/form-data'
            }
          }
        })
          .then((response) => {
            this.$emit('file-submitted', response.data.job_id);
          })
          .catch((response) => {
            // console.log(response.response.data.error);
            this.$emit('alert', 'ERROR ' + response.response.data.error);
          })
      } else {
        this.$emit('alert', 'Please fill all the fields to upload your manifest');
      }

    },
  }
}
</script>

<style scoped>
.custom-height {
  padding-top: 100px;
}

.upload-view{
  padding-top: 100px;
}

.text-center{

}

</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/InVoicesUploadHeader.vue